import React from 'react'
import classnames from 'classnames'
import { node, string, oneOfType, arrayOf } from 'prop-types'
import './StackableCollapsibleCard.scss'

const CollapsibleCardContent = ({ className, children }) => (
    <div className={classnames('collapsible-card columns mx-0 my-0 px-0 py-0', className)}>
        <div className='column is-1' />
        <div className='underlined-entry column is-10 is-multiline columns mx-0 my-0 py-1 px-0'>
            {children}
        </div>
    </div>
)

CollapsibleCardContent.propTypes = {
    className: string,
    children: oneOfType([arrayOf(node), node]).isRequired
}

export default CollapsibleCardContent